import React, { useContext } from "react";

import { useParams } from "react-router-dom";

import AnswersContext from "../contexts/AnswersContext";

import Breadcrumbs from "./Breadcrumbs";
import Question from "./Question";

const QuestionPage = (props) => {
  let { categoryParam, topicParam, questionID } = useParams();
  let { onAnswerChange } = useContext(AnswersContext);
  return (
    <div>
      <Breadcrumbs
        category={categoryParam}
        topic={topicParam}
        question={questionID}
      />
      <Question
        questionID={questionID}
        showNumbers={true}
        showAnswers={true}
        onReset={() => {
          onAnswerChange(questionID, "");
        }}
      />
    </div>
  );
};

export default QuestionPage;
